import { sweetAlert } from 'bmAlert'
export function openValetModal($event): void {
  $event.stopPropagation()
  sweetAlert.confirm({
    title: `<div class="text-no-transform d-flex flex-column text-left"><span>VERBLIO VALET</span></div>`,
    text: `<p class="font-weight-light mb-0">We will manage the Verblio platform for you</p>
          <ul>
            <li class="font-weight-light">HubSpot Inbound-Certified account manager</li>
            <li class="font-weight-light">Dedicated point-person for all your questions</li>
            <li class="font-weight-light">Get help building teams of specialized writers for your niche</li>
            <li class="font-weight-light">Highly personalized service that works with your workflow</li>
          </ul>
          <p class="font-italic font-weight-light">Note: Verblio Valet needs a 3 month commitment.</p>
          `,
    confirmButtonText: 'Close',
    cancelButtonText: 'More info',
  }).then(confirm => {
    if (confirm) return
    window.open("https://help.verblio.com/en/articles/6242229-what-is-verblio-valet", "_blank")
  })
}

export function openCommitmentModal(): void {
  sweetAlert.confirm({
    title: `<div class="text-no-transform"><span>Looking for smart savings?</span></div>`,
    text: `<p>A monthly subscription gives you the most flexibility, while a longer commitment will get you our best discounts—and no matter your term length you'll never have to pay more than one month at a time.</p>
          <p>To ensure no lag in service, all plans auto-renew unless you cancel before the term ends. Rest assured, we'll send reminders so that you can make changes in advance.</p>
          <p>Verblio Valet needs a 3 month commitment so that our team can attune to your needs.</p>`,
    confirmButtonText: 'Close',
    cancelButtonText: 'Learn even more',
  }).then(confirm => {
    if (confirm) return
    window.open("https://help.verblio.com/en/articles/6242242-what-subscription-term-lengths-does-verblio-offer", "_blank")
  })
}

export function openWordLenghtModal(): void {
  sweetAlert.confirm({
    title: '<div class="text-uppercase text-left">More word lengths available in the app</div>',
    text: '<p class="font-weight-light mb-0">Custom word lengths are available in the app in 100 word increments between 300 and 4,000 words.</p>',
    confirmButtonText: 'Close',
    showCancelButton: false,
  }).then(confirm => {
    if (confirm) return
    window.open("https://help.verblio.com/en/articles/6241900-what-word-lengths-does-verblio-offer", "_blank")
  })
}
